import React, { useState } from "react";
import PropTypes from "prop-types";
import Button from "components/Button";
import Modal from "react-modal";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { collection, addDoc } from "firebase/firestore";
import Loader from "components/Loader";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";

const customStyles = {
	overlay: {
		zIndex: 1000,
		backgroundColor: "rgb(56 67 54 / 90%)",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		padding: "24px",
		outline: "none",
	},
	content: {
		position: "relative",
		border: "none",
		borderRadius: "25px",
		backgroundColor: "#fff",
		maxWidth: "800px",
		minHeight: "300px",
		minWidth: "380px",
		outline: "none",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		width: "80vw",
		padding: "24px",
		boxSizing: "border-box",
	},
};

const Wrapper = styled.div``;

const ModalContentContainer = styled.div`
	max-width: 600px;
	min-width: 340px;
`;

const Title = styled.h1`
	font-size: 40px;
	color: #3e5042;
	font-weight: 700;
	text-align: center;
`;

const Description = styled.p`
	font-size: 24px;
	color: #3e5042;
	font-weight: 400;
	text-align: center;
	padding-bottom: 40px;
`;

const ConfirmedDescription = styled.p`
	font-size: 20px;
	color: #3e5042;
	font-weight: 400;
	text-align: center;
`;

const InputWrapper = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 24px;

	label {
		color: rgb(56 67 54 / 60%);
	}
	input {
		color: #3e5042;
		border: none;
		font-size: 16px;
		padding-top: 4px;
		padding-bottom: 4px;
		border-bottom: 1px solid grey;
		outline: none;
		text-transform: capitalize;
	}
	input#email {
		text-transform: unset;
	}
	input#email::first-word {
		text-transform: capitalize;
	}
`;

const CloseButton = styled.div`
	position: absolute;
	top: 0;
	right: 0;
	cursor: pointer;

	svg {
		height: 60px;
		width: 60px;
	}
`;

const BookFremvisningPopup = (props) => {
	const { modalIsOpen, setModalIsOpen, title, description } = props;

	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [phoneNumber, setPhoneNumber] = useState("");
	const [sendingMessage, setSendingMessage] = useState(false);
	const [messageSent, setMessageSent] = useState(false);

	const { t } = useTranslation();

	const closeModal = () => setModalIsOpen(false);

	const onNameChange = (e) => setName(e.target.value);
	const onEmailChange = (e) => setEmail(e.target.value);
	const onPhoneNumberChange = (e) => setPhoneNumber(e.target.value);

	initializeApp({
		apiKey: "AIzaSyCoIfG8XEBXDaGy9ntdckgrf-IFRpKaRaY",
		authDomain: "norsepm-dk-fac16.firebaseapp.com",
		projectId: "norsepm-dk-fac16",
	});

	const db = getFirestore();

	async function writeFormSubmit(event) {
		event.preventDefault();
		setSendingMessage(true);

		if (name && email && phoneNumber) {
			try {
				await addDoc(collection(db, "contact-formula"), {
					to: "udlejning@norsepm.dk",
					message: {
						subject: `Forespørgsel om fremvisning - Skovstykket${title ? ` - ${title}` : ""}`,
						html: `Navn: ${name}</br>Email: ${email}</br>Telefon: ${phoneNumber}</br>Url: ${window.location.href}${title ? `</br>Bygning/Område: ${title}` : ""}${description ? `</br>Beskrivelse: ${description}` : ""}`,
					},
				});
				setName("");
				setEmail("");
				setPhoneNumber("");
				setMessageSent(true);
			} catch (e) {
				console.error("Error adding document: ", e);
				alert("Et teknisk problem opstod. Beklager ulejligheden.");
			}
		} else {
			alert("Alle felter skal udfyldes");
		}
		setSendingMessage(false);
	}

	return (
		<Wrapper>
			<Modal
				isOpen={modalIsOpen}
				onRequestClose={closeModal}
				style={customStyles}
				className={"interestlist-modal"}
				ariaHideApp={false}
			>
				<CloseButton onClick={closeModal}>
					<CloseIcon />
				</CloseButton>
				<ModalContentContainer>
					{!sendingMessage && !messageSent && (
						<>
							<Title>{title ? `Book fremvisning - ${title}` : "Book en fremvisning"}</Title>
							<Description>
								{description || "Udfyld formularen, så vender vi tilbage hurtigst muligt for at aftale en fremvisning."}
							</Description>
							<InputWrapper>
								<label htmlFor="name">{t("contact.name")}*</label>
								<input value={name} onChange={onNameChange} id="name" type="text" />
							</InputWrapper>
							<InputWrapper>
								<label htmlFor="email">{t("contact.email")}*</label>
								<input value={email} onChange={onEmailChange} id="email" type="text" />
							</InputWrapper>
							<InputWrapper>
								<label htmlFor="phone">{t("contact.phone")}*</label>
								<input value={phoneNumber} onChange={onPhoneNumberChange} id="phone" type="text" />
							</InputWrapper>
							<Button
								onClick={writeFormSubmit}
								style={{
									marginTop: "40px",
									marginLeft: "auto",
									marginRight: "auto",
									marginBottom: "20px",
									display: "block",
								}}
							>
								Send forespørgsel
							</Button>
						</>
					)}
					{sendingMessage && !messageSent && <Loader />}
					{!sendingMessage && messageSent && (
						<>
							<Title>Tak for din forespørgsel</Title>
							<ConfirmedDescription>
								Vi har modtaget din henvendelse og vender tilbage hurtigst muligt for at aftale en fremvisning.
							</ConfirmedDescription>
							<Button
								onClick={closeModal}
								style={{ marginTop: "80px", marginLeft: "auto", marginRight: "auto", display: "block" }}
							>
								Afslut
							</Button>
						</>
					)}
				</ModalContentContainer>
			</Modal>
		</Wrapper>
	);
};

BookFremvisningPopup.propTypes = {
	modalIsOpen: PropTypes.bool.isRequired,
	setModalIsOpen: PropTypes.func.isRequired,
	title: PropTypes.string,
	description: PropTypes.string,
};

export default BookFremvisningPopup;
